import { MotorStatusMdl } from "./MotorStatusMdl";

export class loginRes
{
public RegNo:string;
public IqamaNo:string;
public Insuredtoken:string;
public token:string;
public Name:string;
public NameAr:string;
public Lng:string;
public Nationality: string;
public NationalityAr: string;
public st:MotorStatusMdl=new MotorStatusMdl();

}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/loginRes.ts